import 'isomorphic-fetch'
import { checkHttpStatus, getApiHeaders, getApiBaseUrlWithOrg } from '../utils'
import { fetchQuest } from './quest'
import { basicGet } from '../utils/api'
import { getErrorAction } from '../utils/actions'
import { questIsAssignedToUser } from '../utils/assignment'

export const OPEN_TO_QUALITY_REVIEW_MODAL = 'OPEN_TO_QUALITY_REVIEW_MODAL'
export const CLOSE_TO_QUALITY_REVIEW_MODAL = 'CLOSE_TO_QUALITY_REVIEW_MODAL'
export const CREATE_COMPILED_QUEST_REQUEST = 'CREATE_COMPILED_QUEST_REQUEST'
export const CREATE_COMPILED_QUEST_SUCCESS = 'CREATE_COMPILED_QUEST_SUCCESS'
export const CREATE_COMPILED_QUEST_REVIEW_SUCCESS =
  'CREATE_COMPILED_QUEST_REVIEW_SUCCESS'
export const DELETE_COMPILED_QUEST_REVIEW_SUCCESS =
  'DELETE_COMPILED_QUEST_REVIEW_SUCCESS'
export const COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS =
  'COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS'
export const EDIT_REVIEW_SUCCESS = 'EDIT_REVIEW_SUCCESS'
export const STOP_REVIEW_SUCCESS = 'STOP_REVIEW_SUCCESS'
export const REVERT_QUEST_TO_DRAFT_SUCCESS = 'REVERT_QUEST_TO_DRAFT_SUCCESS'
export const REQUEST_CURRENT_COMPILED_QUEST = 'REQUEST_CURRENT_COMPILED_QUEST'
export const RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS =
  'RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS'
export const RECEIVE_CURRENT_COMPILED_QUEST_FAILURE =
  'RECEIVE_CURRENT_COMPILED_QUEST_FAILURE'

export function requestCurrentCompiledQuest() {
  return {
    type: REQUEST_CURRENT_COMPILED_QUEST
  }
}

export function openToQualityReviewModal() {
  return {
    type: OPEN_TO_QUALITY_REVIEW_MODAL
  }
}

export function closeToQualityReviewModal() {
  return {
    type: CLOSE_TO_QUALITY_REVIEW_MODAL
  }
}

export function stopReviewSuccess(questId) {
  return {
    type: STOP_REVIEW_SUCCESS,
    questId: questId
  }
}

export function createCompiledQuestReviewSuccess(response) {
  return {
    type: CREATE_COMPILED_QUEST_REVIEW_SUCCESS,
    review: response
  }
}

export function deleteCompiledQuestReviewSuccess(reviewId) {
  return {
    type: DELETE_COMPILED_QUEST_REVIEW_SUCCESS,
    reviewId: reviewId
  }
}

export function editReviewSuccess(response) {
  return {
    type: EDIT_REVIEW_SUCCESS,
    review: response
  }
}

export function completeCompiledQuestReviewSuccess(
  response,
  reviewState,
  questId
) {
  return {
    type: COMPLETE_COMPILED_QUEST_REVIEW_SUCCESS,
    payload: {
      review: response,
      reviewState: reviewState,
      questId: questId
    }
  }
}

export function createCompiledQuestSuccess(
  response,
  questId,
  userIsAssignedQuest
) {
  return {
    type: CREATE_COMPILED_QUEST_SUCCESS,
    payload: {
      compiled_quest: response,
      questId: questId,
      userIsAssignedQuest: userIsAssignedQuest
    }
  }
}

export function createCompiledQuestRequest() {
  return {
    type: CREATE_COMPILED_QUEST_REQUEST
  }
}

export function receiveCurrentCompiledQuestSuccess(response) {
  return {
    type: RECEIVE_CURRENT_COMPILED_QUEST_SUCCESS,
    compiledQuest: response
  }
}

export function receiveCurrentCompiledQuestFailure(error) {
  return getErrorAction(RECEIVE_CURRENT_COMPILED_QUEST_FAILURE, error)
}

export function revertQuestToDraftSuccess(published, quest) {
  return {
    type: REVERT_QUEST_TO_DRAFT_SUCCESS,
    payload: {
      published: published,
      quest
    }
  }
}

export function stopReview(questId, compiledQuestId) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/recall`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1',
            'Content-Type': 'application/json'
          }
        })
      )
      dispatch(stopReviewSuccess(questId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function revertQuestToDraft(questId, published) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            quest: {
              clear_review: true
            }
          })
        })
      )
      const json = await response.json()
      dispatch(revertQuestToDraftSuccess(published, json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function completeCompiledQuestReview(
  questId,
  compiledQuestId,
  reviewId,
  nextState
) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              completed: true
            }
          })
        })
      )
      const json = await response.json()
      dispatch(completeCompiledQuestReviewSuccess(json, nextState, questId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function editReviewComment(questId, compiledQuestId, reviewId, comment) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              comment: comment
            }
          })
        })
      )
      const json = await response.json()
      dispatch(editReviewSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function nullifyReviewCriterionApproval(
  questId,
  compiledQuestId,
  reviewId
) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              accepted: null
            }
          })
        })
      )
      const json = await response.json()
      dispatch(editReviewSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function rejectReviewCriterion(questId, compiledQuestId, reviewId) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              accepted: false
            }
          })
        })
      )
      const json = await response.json()
      dispatch(editReviewSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function approveReviewCriterion(questId, compiledQuestId, reviewId) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'PATCH',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              accepted: true
            }
          })
        })
      )
      const json = await response.json()
      dispatch(editReviewSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function deleteCompiledQuestReview(questId, compiledQuestId, reviewId) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews/${reviewId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state)
        })
      )
      dispatch(deleteCompiledQuestReviewSuccess(reviewId))
    } catch (error) {
      console.log(error)
    }
  }
}

export function createCompiledQuestReview(
  questId,
  compiledQuestId,
  reviewType
) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}/reviews`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            compiled_quest_review: {
              criteria: reviewType
            }
          })
        })
      )
      const json = await response.json()
      dispatch(createCompiledQuestReviewSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function fetchCurrentCompiledQuest(questId, compiledQuestId) {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/compiled_quests/${compiledQuestId}`
    return basicGet(
      state,
      dispatch,
      url,
      requestCurrentCompiledQuest,
      receiveCurrentCompiledQuestSuccess,
      receiveCurrentCompiledQuestFailure
    )
  }
}

export function createCompiledQuest(id) {
  return async (dispatch, getState) => {
    const state = getState()
    dispatch(createCompiledQuestRequest())
    const userIsAssignedQuest = questIsAssignedToUser(
      state.quest.item,
      state.user.user
    )
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${id}/compiled_quests`
    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state)
        })
      )
      const json = await response.json()
      await dispatch(createCompiledQuestSuccess(json, id, userIsAssignedQuest))
      dispatch(closeToQualityReviewModal())
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/review.js